import { isEmpty } from 'lodash';

import { FormikSelectOption, ColumnsDropdown } from 'components';
import { useQueryColumns } from 'hooks';

type Props = {
  title?: string;
  availableColumns: FormikSelectOption[];
};

export const QueryColumns: React.FC<Props> = ({ title, availableColumns }) => {
  const { visibleColumns, resetVisibleColumns, setVisibleColumns } =
    useQueryColumns();

  if (isEmpty(availableColumns)) {
    return null;
  }

  return (
    <ColumnsDropdown
      title={title}
      visibleColumns={visibleColumns}
      availableColumns={availableColumns}
      onReset={resetVisibleColumns}
      onSubmit={setVisibleColumns}
    />
  );
};
